/**
 * A whitelist de nomes de campo de `telemetry_sources.unsupported_fields`.
 *
 * MODULO PROPRIO, e nao um bloco de `index.ts`, por uma razao mecanica: os
 * envelopes de frota (`fleet.ts`) precisam de `UnsupportedField`, e `index.ts`
 * reexporta `fleet.ts`. Importar de `index.ts` la fecharia um ciclo que o
 * resolvedor de modulos recusa -- medido: seis erros `TS2305: has no exported
 * member`. Tipo compartilhado por dois modulos que o barril reexporta mora fora
 * do barril.
 */
/**
 * A WHITELIST de nomes de campo que podem aparecer em
 * `telemetry_sources.unsupported_fields`.
 *
 * ESTA CONSTANTE E O `CHECK` DA MIGRATION 0026 SÃO PROVADOS IGUAIS POR TESTE
 * (`apps/server/src/fleet-source-whitelist.test.ts`), que lê
 * `pg_get_constraintdef` do banco e compara com `Object.keys` daqui. Sem essa
 * amarra, um typo (`cell_temp_average`) vira "campo suportado" EM SILÊNCIO: o
 * array `text[]` aceita a string, nenhuma consulta reclama, e a falha só
 * aparece na tela como uma coluna que deveria ter sumido e continua imprimindo
 * "—" em dezesseis linhas. É a mesma disciplina do `PLAIN_IDENTIFIER` que valida
 * `SHADOWED_RELATIONS` em tempo de carga de módulo.
 *
 * O objeto existe (em vez de um array direto) porque a união de tipos e a lista
 * em runtime têm de ser a MESMA coisa: `keyof typeof` dá o tipo, `Object.keys`
 * dá os valores, e não há como acrescentar um sem o outro.
 *
 * Os nomes são os do BANCO (`snake_case`), não os do contrato TS: eles viajam
 * dentro de `unsupported_fields` e são comparados contra nomes de coluna.
 *
 * CINCO nomes NÃO são colunas de `vehicle_telemetry`, e é deliberado — o que a
 * lista descreve é "grandeza **ou CAPACIDADE** que a fonte não entrega", não
 * "coluna que existe". É a mesma formulação de `campos-carregador.ts`, onde
 * `remote_control` e `configuration` são capacidades:
 *   `soh_pct`             — a MV `battery_health_estimated` deriva de
 *                           `signalstore_raw` (sinal 0009, temperatura de
 *                           célula), que o Datalbus não escreve;
 *   `gps_trail`           — o rastro de `/api/telemetria-frota/veiculo/:vin/detail`
 *                           vem de `signalstore_raw`, pela mesma razão;
 *   `performance_samples` — `vehicle_performance_samples` só tem um escritor
 *                           (`services/signalstore/consumer.py:156`), parado.
 *   `signalstore_raw`     — a fonte não escreve `public.signalstore_raw`. O
 *                           Datalbus é um `mysql_fdw` sobre `vgpl.fleet_live`,
 *                           que é tabela de ESTADO CORRENTE e não fluxo de
 *                           mensagens: não há caminho. É o que permite o KPI de
 *                           saúde do coletor em `/api/dashboard/routines`
 *                           distinguir "zero porque o coletor caiu" de "zero
 *                           porque esta pergunta não se aplica a esta fonte" —
 *                           e sem ele aquele KPI publicava 31,9 dias de atraso
 *                           de uma frota invisível como estado corrente.
 *   `telemetry_push`      — **o mais sutil dos cinco, e o único que não é sobre
 *                           ausência de dado, e sim sobre o SIGNIFICADO dele.**
 *                           `vehicle_telemetry.updated_at` NÃO é o relógio do
 *                           veículo em NENHUMA das duas fontes, e as duas erram
 *                           diferente: o consumer do FleetBus grava
 *                           `updated_at = NOW()` (relógio NOSSO, na ingestão,
 *                           descartando `signalstore_raw.vehicle_ts`), e o
 *                           `datalbus_sync.sql` COPIA
 *                           `vgpl.fleet_live.updated_at` (relógio da integração
 *                           VGPL↔Nansen, da ORIGEM). Listar este nome significa
 *                           "o carimbo é da origem, copiado"; não listá-lo
 *                           significa "é do nosso consumer, na ingestão".
 *                           `fleet_snapshot.telemetry_means` publica qual dos
 *                           dois, e é o análogo exato de
 *                           `charger_visible.contact_means`.
 *                           CONSEQUÊNCIA PARA QUEM LÊ `ageSeconds`: ele mede "há
 *                           quanto tempo o NOSSO pipeline tocou esta linha", não
 *                           "há quanto tempo o ônibus falou".
 */
const WHITELIST_DE_CAMPOS = {
    soc_pct: true,
    range_km: true,
    energy_available_kwh: true,
    cell_temp_avg: true,
    cell_temp_max: true,
    speed_kmh: true,
    odometer_km: true,
    ignition: true,
    handbrake: true,
    gps_lat: true,
    gps_lon: true,
    gps_speed_kmh: true,
    gps_course: true,
    gps_sats: true,
    gps_ts: true,
    plug_charging: true,
    charging_power_kw: true,
    motor_torque_nm: true,
    air_temp_outside: true,
    air_temp_inside: true,
    battery_12v_voltage: true,
    soh_pct: true,
    gps_trail: true,
    performance_samples: true,
    msg_count: true,
    first_seen: true,
    signalstore_raw: true,
    telemetry_push: true,
};
/**
 * A whitelist em runtime, na MESMA ordem do `CHECK` da migration 0026.
 *
 * A ordem importa para o teste de igualdade (comparação de arrays ordenados
 * seria tolerante a reordenação, e reordenar não é erro — mas manter as duas na
 * mesma ordem é o que torna a divergência legível no diff).
 */
export const UNSUPPORTED_FIELDS = Object.freeze(Object.keys(WHITELIST_DE_CAMPOS));
